import { $_app_server } from '@/_helpers'

export const actService = {
    loadMyAct,
    downloadAct,
    saveLoadActs,
    downloadSignedAct,
    getAvailableYears,
    getNotViewedMyAct,
    checkAct,
    showTempfiles,
    deleteTmpFile
}

let func = (response) => response.data

function loadMyAct(month, year) {
  return $_app_server.get(`act/getMyAct?month=${month}&year=${year}`).then(func)
}

function downloadAct(actId) {
  return $_app_server.get(`act/downloadAct?actId=${actId}`, {
    responseType: 'blob'
  })
}

function saveLoadActs(obj) {
    return $_app_server.post('act/saveSignedActs', obj).then(func)
}

function downloadSignedAct(actId) {
  return $_app_server.get(`act/downloadSignedAct?actId=${actId}`, {
    responseType: 'blob'
  })
}

function getAvailableYears() {
  return $_app_server.get(`act/availableYears`).then(func)
}

function getNotViewedMyAct() {
  return $_app_server.get(`act/getNotViewedMyAct`).then(func)
}

function checkAct(actId) {
  return $_app_server.post(`act/checkAct?actId=${actId}`).then(func)
}

function showTempfiles(file) {
  return $_app_server.get(`act/tempfiles/${file.uuid}.${file.extension}?extension=${file.extension}`,{
    responseType: 'blob'
  })
}

function deleteTmpFile(filename) {
  return $_app_server.delete(`act/deleteTmp?filename=${filename}`).then(func)
}
